import React from "react";
import moment from "moment";



export default class MessageDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        const vm = this.props.vm;

        return (
            <div className="ap-message-panel container-fluid">
                <div className="row">
                    <ul className="col-md-6 no-bullet">
                        <li>
                            <span>From: </span>
                            <span>{ vm.senderName }</span>

                        </li>
                        <li>
                            <span>Date received: </span>
                            <span>{ moment(vm.creationDate).format("M/D/YYYY h:mm A") }</span>
                        </li>
                    </ul>
                    <ul className="col-md-6 no-bullet">
                        <li>
                            <span>Subject: </span>
                            <span>{ vm.subject }</span>
                        </li>
                    </ul>
                </div>
                <div className="row">
                    <div className="col-md-12 body-text" >
                        <span dangerouslySetInnerHTML={ { __html: vm.message } } />
                    </div>
                </div>
            </div>
        );
    }
}